export const CFG_TR = {
    cfg_gen: 'cfg_general',
    
    reporting: 'others_reporting',
    settings: 'admin_settings'
};